import { axiosInstance } from "./axiosInstance";

function getUserProfile(data) {
    return axiosInstance.get('profile/show', { params: data });
}

function sendToFriend(data) {
    return axiosInstance.post('send-profile-to-friend', data);
}

function getMemberList({treatment_id, account_type}) {
    return axiosInstance.get(`profile/member_list?treatment_id=${treatment_id}&&account_type=${account_type}`);
}

export {
    getUserProfile,
    sendToFriend,
    getMemberList
}